import $ from 'jquery';
import * as config from '../config/config';
import cokeStorage, { checkNested } from './utils';
class Auth {
  getCorpID() {
    this.appId = config.APPID;
    this.mpWorkAppId = config.MPWORKAPPID;
    const url = config.API.getcorpid(this.appId, this.mpWorkAppId);
    return new Promise((resolve, reject) => $.getJSON(url).then((res) => {
      if (checkNested(res, 'content', 'model')) {
        const cropid = res.content.model;

        resolve(cropid);
        cokeStorage.setItem('cropid', cropid);
      } else {
        reject();
      }
    }));
  }

  getLocalAccessToken() {
    this.accesstoken = cokeStorage.getItem('access_token');
    return this.accesstoken;
  }

  getLocalUserRole() {
    this.role = cokeStorage.getItem('role');
    return this.role;
  }

  getLocalRefreshToken() {
    this.refreshtoken = cokeStorage.getItem('refresh_access_token');
    return this.refreshtoken;
  }

  setLocalAccessToken(model) {
    const { accessToken, refreshAccessToken, role, securityGuardPost, language } = model;
    this.accesstoken = accessToken;
    this.refreshAccessToken = refreshAccessToken;
    const currentTime = new Date();
    cokeStorage.setItem('currentTime', currentTime.getTime());
    cokeStorage.setItem('access_token', accessToken);
    cokeStorage.setItem('refresh_access_token', refreshAccessToken);
    cokeStorage.setItem('role', role);
    cokeStorage.setItem('securityGuardPost', securityGuardPost);
    localStorage.setItem('localeLanguage', language === 'en-US' ? 'en' : 'zh');
  }
  
  checkToken() {
    const currentTime = new Date();
    const getLocalStoryTime = cokeStorage.getItem('currentTime');
    if ((currentTime - getLocalStoryTime) > 30*60*1000) {
      return true;
    } else {
      return false;
    } 
  }

  getAccessToken(code) {
    this.code = code;
    const url = config.API.accesstoken(code);

    return new Promise((resolve, reject) => $.getJSON({
      url,
      xhrFields: {
        withCredentials: true,
      },
    }).then((res) => {
      if (res.status === '004') {
        reject(res.message);
        return false;
      }

      if (checkNested(res, 'content', 'model', 'accessToken')) {
        resolve(res.content.model);
      } else {
        reject(res.content.message);
      }

      return true;
    }));
  }

  getAccessTokenDebug(userid, isExternal) {
    this.userid = userid;

    let url;
    if (isExternal) {
      url = config.API.accesstokenLocalExternal(userid);
    } else {
      url = config.API.accesstokenLocal(userid);
    }

    return new Promise((resolve, reject) => $.getJSON({
      url,
      xhrFields: {
        withCredentials: true,
      },
    }).then((res) => {
      if (res.status === '004') {
        reject(res.message);
        return false;
      }

      if (checkNested(res, 'content', 'model', 'accessToken')) {
        resolve(res.content.model);
      } else {
        reject(res.content.message);
      }

      return true;
    }));
  }

  getRefreshAccessToken() {
    const t = this;
    this.mpWorkAppId = config.MPWORKAPPID;
    const url = config.API.refreshtoken;
    const token = this.getLocalAccessToken();
    const refreshtoken = this.getLocalRefreshToken();

    return new Promise((resolve, reject) => $.post({
      url,
      xhrFields: {
        withCredentials: true,
      },
      data: {
        MpworkAppId: config.MPWORKAPPID,
        Token: token,
        RefreshToken: refreshtoken,
      },
    }).then((res) => {
      if (res.content && res.content.status === 2) {
        t.goLogin();
        return false;
      }

      if (res.status === '004') {
        reject(res.message);
        return false;
      }

      if (checkNested(res, 'content', 'model', 'accessToken')) {
        resolve(res.content.model);
      } else {
        reject(res.content.message);
      }

      return true;
    }));
  }

  goLogin() {
    this.getCorpID()
      .then((cropid) => {
        const redirectUri = window.location.href;
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${cropid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${config.MPWORKAPPID}#wechat_redirect`;
        window.location.href = url;
      });
  }

  isLogin() {
    return this.getLocalAccessToken();
  }

  getAccessTokenExternal(id, token) {
    const url = config.API.accessTokenExternal(id, token);

    return new Promise((resolve, reject) => $.getJSON({
      url,
      xhrFields: {
        withCredentials: true,
      },
    }).then((res) => {
      if (res.status === '004') {
        reject(res.message);
        return false;
      }
      if (res.content && res.content.status === 2) {
        reject(res.content.message);
        return false;
      }
      if (checkNested(res, 'content', 'model', 'accessToken')) {
        resolve(res.content.model);
      } else {
        reject(res.content.message);
        return false;
      }

      return true;
    }));
  }

  getRefreshAccessTokenExternal() {
    const t = this;
    const url = config.API.refreshtokenExternal;
    const token = t.getLocalAccessToken();
    const refreshtoken = t.getLocalRefreshToken();

    return new Promise((resolve, reject) => $.post({
      url,
      xhrFields: {
        withCredentials: true,
      },
      data: {
        Token: token,
        RefreshToken: refreshtoken,
      },
    }).then((res) => {
      if (res.status === '004') {
        reject(res.message);
        return false;
      }

      if (res.content && res.content.status === 2) {
        reject(res.content.message);
        return false;
      }

      if (checkNested(res, 'content', 'model', 'accessToken')) {
        resolve(res.content.model);
      } else {
        reject(res.content.message);
        return false;
      }

      return true;
    }));
  }

  logoutExternal() {
    cokeStorage.removeItem('access_token');
    cokeStorage.removeItem('refresh_access_token');
    cokeStorage.removeItem('role');
    cokeStorage.removeItem('currentTime');
    window.location.href = window.location.origin + '/external/login';
  }
}

export default new Auth();
